export default {
  nav: {
    home: "Home",
    products: "Products",
    catalog: "Catalog",
    about: "About Us",
    contact: "Contact",
    language: "Language",
  },
  hero: {
    title: "Quality Products for Every Need",
    subtitle:
      "Discover our premium collection designed to exceed your expectations",
    cta: "View Catalog",
    secondary: "Explore Products",
    viewAll: "View All Products",
  },
  products: {
    title: "Our Products",
    subtitle: "Explore our carefully curated selection of premium products",
    viewAll: "View All Products",
  },
  productCard: {
    viewDetails: "View Details",
    learnMore: "Learn More",
  },
  about: {
    title: "About Us",
    companyName: "Hebei Qianqin Metal Material Co., LTD",
    address: "Anping County, Hebei Province, China",
    manager: "Manager Cici",
    managerPhone: "+86 18000609698",
    mrJake: "Mr. Jake",
    mrJakePhone1: "+86 18395601011",
    mrJakePhone2: "+86 15831188937",
    emailCici: "cici@qianqin-group.com",
    emailJake: "jake@qianqin-group.com",
    emailJames: "james@qianqin-group.com",
    website: "www.qianqin-group.com",
    scanQR: "Scan QR Code",
    whatsapp: "WhatsApp",
    wechat: "WeChat",
  },
  catalog: {
    title: "Product Catalog",
    download: "Download PDF",
    print: "Print Catalog",
    pdf: "/pdf/Qianqin-catalogue.pdf",
  },
  footer: {
    copyright: "© 2026 Qianqin. All rights reserved.",
    rights: "All rights reserved.",
  },
  common: {
    loading: "Loading...",
    error: "Something went wrong",
    retry: "Retry",
  },
  productsList: [
    {
      id: "1",
      name: "Premium Product A",
      description:
        "High-quality product with exceptional performance and durability. Perfect for everyday use.",
      image:
        "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=800&q=80",
      pdf: "/pdf/Qianqin-catalogue.pdf",
    },
    {
      id: "2",
      name: "Premium Product B",
      description:
        "Innovative design meets functionality. Experience the difference with our premium offerings.",
      image:
        "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=800&q=80",
      pdf: "/pdf/Qianqin-catalogue.pdf",
    },
    {
      id: "3",
      name: "Premium Product C",
      description:
        "Crafted with precision and care. Our products are built to exceed expectations.",
      image:
        "https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=800&q=80",
      pdf: "/pdf/Qianqin-catalogue.pdf",
    },
    {
      id: "4",
      name: "Premium Product D",
      description:
        "Advanced engineering meets elegant design. Built for professionals who demand excellence.",
      image:
        "https://images.unsplash.com/photo-1504274066631-90dd72c89d6d?w=800&q=80",
      pdf: "/pdf/Qianqin-catalogue.pdf",
    },
    {
      id: "5",
      name: "Premium Product E",
      description:
        "Superior quality materials combined with cutting-edge technology. The future of productivity.",
      image:
        "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=800&q=80",
      pdf: "/pdf/Qianqin-catalogue.pdf",
    },
    {
      id: "6",
      name: "Premium Product F",
      description:
        "Meticulously designed for maximum efficiency. Experience unmatched performance.",
      image:
        "https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=800&q=80",
      pdf: "/pdf/Qianqin-catalogue.pdf",
    },
  ],
};
